export default {
  text: "hsl(204, 44%, 13%)",

  lightText: "#007CC7",

  background: "hsl(201, 66%, 58%)",

  shadowText: "#203647",

  shadowBackground: "#EEFBFB",
};

// These are the colors that are exported:

// - Dark Blue: #12232E

// - Lighter Blue: #007CC7

// - Lightest Blue: #4DA8DA

// - Shadow of Dark Blue: #203647

// - Shadow of Light Blue: #EEFBFB
